import { createContext, useRef, useState } from "react";

export const DashboardContext = createContext();
const DashboardProvider = ({children}) =>{
    const [dashboardSummary,setDashboardSummary] = useState(null);
    const [dashboardSummaries,setDashboardSummaries] = useState(null);
    const [dashboard,setDashboard] = useState(null);
    const [selectedServerUrl,setSelectedServerUrl] = useState(null);
    const [selectedTenantAdminProfile,setSelectedTenantAdminProfile] = useState(null);
    const [fetchDashboard,setFetchDashboard] = useState(null);
    const [editMode,setEditMode] = useState(false);
    const [showWidgetsLibrary,setShowWidgetsLibrary] = useState(false);
    const [dashboardStates, setDashboardStates] = useState([]);
    const [showManageDashboardStates,setShowManageDashboardStates] = useState(false);
    const [showNewDashboardState,setShowNewDashboardState] = useState(false);
    const [selectedEditDashboardState, setSelectedEditDashboardState] = useState(null);
    const [showEditDashboardState,setShowEditDashboardState] = useState(false);
    const [activeDashboardState,setActiveDashboardState] = useState(null);
    const [showEditWidget,setShowEditWidget] = useState(false);
    const [activeEditWidget,setActiveEditWidget] = useState(null);
    const [selectedNewWidgetWindow,setSelectedNewWidgetWindow] = useState('');
    const [maximizedWidget,setMaximizedWidget] = useState(null);
    const refreshDashboardState = useRef(false);
    return(
        <DashboardContext.Provider value={{
            dashboardSummary,setDashboardSummary,
            dashboardSummaries,setDashboardSummaries,
            dashboard,setDashboard,
            selectedServerUrl,setSelectedServerUrl,
            selectedTenantAdminProfile,setSelectedTenantAdminProfile,
            fetchDashboard,setFetchDashboard,
            editMode,setEditMode,
            showWidgetsLibrary,setShowWidgetsLibrary,
            dashboardStates,setDashboardStates,
            showManageDashboardStates,setShowManageDashboardStates,
            showNewDashboardState,setShowNewDashboardState,
            selectedEditDashboardState,setSelectedEditDashboardState,
            showEditDashboardState,setShowEditDashboardState,
            activeDashboardState,setActiveDashboardState,
            showEditWidget,
            setShowEditWidget,
            activeEditWidget,
            setActiveEditWidget,
            selectedNewWidgetWindow,setSelectedNewWidgetWindow,
            maximizedWidget,setMaximizedWidget,
            refreshDashboardState
        }}
        >{children}</DashboardContext.Provider>
    );
};
export default DashboardProvider;